import _ from 'lodash';
import React from 'react';
import type { InvitationUserSelectOptionType } from './InvitationUserSelect';
import InvitationUserSelect from './InvitationUserSelect';
import useInvitationAutocompleteQuery, {
  ExternalUserState,
} from './useInvitationAutocompleteQuery';

const EXTERNAL_USER_STATE_ORDER: Array<ExternalUserState | undefined> = [
  ExternalUserState.Uninvited,
  ExternalUserState.Invited,
  ExternalUserState.Teammate,
  ExternalUserState.Deactivated,
];

interface InvitationUserSelectFieldProps {
  value: InvitationUserSelectOptionType[];
  onChange: (invites: InvitationUserSelectOptionType[]) => void;
  disabled?: boolean;
}

const InvitationUserSelectField = ({
  value,
  onChange,
  disabled,
}: InvitationUserSelectFieldProps) => {
  const { externalUsers } = useInvitationAutocompleteQuery();
  const inviteEmails = new Set(value.map(({ email }) => email));

  const currentExternalUsers = _.sortBy(
    (externalUsers ?? []).map((user) => ({
      ...user,
      state:
        user.state === ExternalUserState.Uninvited &&
        user.email &&
        inviteEmails.has(user.email)
          ? ExternalUserState.Invited
          : user.state,
    })),
    (user) => [EXTERNAL_USER_STATE_ORDER.indexOf(user.state), user.name],
  );

  return (
    <InvitationUserSelect
      value={value}
      onChange={onChange}
      externalUsers={currentExternalUsers}
      placeholder="Enter a name or email of a teammate"
      disabled={disabled}
    />
  );
};

export default InvitationUserSelectField;
